import AnalyticsBase from './AnalyticsBase';

class ItemListEvent extends AnalyticsBase {
  items: Array<{ id: string }>;
}

export default ItemListEvent;
